'use strict';

module.exports = function () {
    var testKey = 'owl_local_test';
    try {
        localStorage.setItem(testKey, 1);
        localStorage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
};